var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title'),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-textarea',{attrs:{"filled":"","name":"input-7-4","label":_vm.mensaje,"auto-grow":"","error-messages":_vm.errores},on:{"input":function($event){return _vm.asignarValor($event)}}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }